import React, { Children } from 'react';
import { MapPin, Phone, Clock, Mail, Facebook, Instagram } from 'lucide-react';
import { motion } from 'framer-motion';
export function Contact() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section id="contact" className="bg-[#1a3a2a] text-white py-24 border-t-4 border-red-600" data-id="element-19">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-20">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center" data-id="element-21">
          <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-100px'
        }} data-id="element-22">
            <motion.h2 variants={itemVariants} className="text-4xl font-heading font-bold mb-6 uppercase tracking-wide" data-id="element-23">
              Visit Us
            </motion.h2>
            <motion.div variants={itemVariants} className="w-16 h-1 bg-red-600 mb-10" data-id="element-24"></motion.div>

            <div className="space-y-8" data-id="element-25">
              <motion.div variants={itemVariants} className="flex items-start gap-5" data-id="element-26">
                <div className="bg-neutral-800 p-3 rounded-full text-red-500 flex-shrink-0" data-id="element-27">
                  <MapPin size={24} data-id="element-28" />
                </div>
                <div className="pt-1" data-id="element-29">
                  <h3 className="font-bold text-xl mb-1 font-heading tracking-wide" data-id="element-30">
                    Location
                  </h3>
                  <p className="text-neutral-300 text-lg" data-id="element-31">Paducah, Kentucky</p>
                </div>
              </motion.div>

              <motion.div variants={itemVariants} className="flex items-start gap-5" data-id="element-32">
                <div className="bg-neutral-800 p-3 rounded-full text-red-500 flex-shrink-0" data-id="element-33">
                  <Phone size={24} data-id="element-34" />
                </div>
                <div className="pt-1" data-id="element-35">
                  <h3 className="font-bold text-xl mb-1 font-heading tracking-wide" data-id="element-36">
                    Phone
                  </h3>
                  <a href="tel:270-933-1035" className="text-neutral-300 hover:text-white transition-colors text-lg" data-id="element-37">
                    (270) 933-1035
                  </a>
                </div>
              </motion.div>

              <motion.div variants={itemVariants} className="flex items-start gap-5" data-id="element-38">
                <div className="bg-neutral-800 p-3 rounded-full text-red-500 flex-shrink-0" data-id="element-39">
                  <Mail size={24} data-id="element-40" />
                </div>
                <div className="pt-1" data-id="element-41">
                  <h3 className="font-bold text-xl mb-1 font-heading tracking-wide" data-id="element-42">
                    Email
                  </h3>
                  <a href="mailto:sun_cheah@yahoo.com" className="text-neutral-300 hover:text-white transition-colors text-lg break-all" data-id="element-43">
                    sun_cheah@yahoo.com
                  </a>
                </div>
              </motion.div>

              <motion.div variants={itemVariants} className="flex items-start gap-5" data-id="element-44">
                <div className="bg-neutral-800 p-3 rounded-full text-red-500 flex-shrink-0" data-id="element-45">
                  <Clock size={24} data-id="element-46" />
                </div>
                <div className="pt-1" data-id="element-47">
                  <h3 className="font-bold text-xl mb-1 font-heading tracking-wide" data-id="element-48">
                    Hours
                  </h3>
                  <p className="text-neutral-300 text-lg" data-id="element-49">
                    Call for current hours of operation.
                  </p>
                </div>
              </motion.div>
            </div>

            <motion.div variants={itemVariants} className="mt-12 pt-8 border-t border-neutral-800" data-id="element-50">
              <h3 className="font-bold text-xl mb-5 font-heading tracking-wide" data-id="element-51">
                Follow Us
              </h3>
              <div className="flex gap-4" data-id="element-52">
                <a href="#" className="bg-neutral-800 p-4 rounded-full hover:bg-red-600 text-white transition-colors" aria-label="Facebook" data-id="element-53">
                  <Facebook size={20} data-id="element-54" />
                </a>
                <a href="#" className="bg-neutral-800 p-4 rounded-full hover:bg-red-600 text-white transition-colors" aria-label="Instagram" data-id="element-55">
                  <Instagram size={20} data-id="element-56" />
                </a>
              </div>
            </motion.div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-white p-10 rounded-3xl shadow-2xl text-black relative overflow-hidden" data-id="element-57">
            <div className="absolute top-0 left-0 w-full h-2 bg-red-600" data-id="element-58"></div>
            <h3 className="text-3xl font-heading font-bold mb-6 text-center tracking-wide" data-id="element-59">
              Ready to order?
            </h3>
            <p className="text-center text-neutral-600 mb-10 text-lg leading-relaxed" data-id="element-60">
              Give us a call to place your order for pickup or delivery. We make
              everything fresh from scratch!
            </p>
            <a href="tel:270-933-1035" className="block w-full bg-red-600 hover:bg-red-700 text-white text-center font-bold py-5 px-6 rounded-xl text-xl transition-all hover:scale-[1.02] active:scale-[0.98] shadow-lg shadow-red-600/20 font-heading tracking-wider" data-id="element-61">
              CALL (270) 933-1035
            </a>
          </motion.div>
        </div>

        <div className="mt-24 pt-8 border-t border-neutral-800 text-center text-neutral-500 text-sm" data-id="element-62">
          <p data-id="element-63">
            &copy; {new Date().getFullYear()} Pizza Warehouse Paducah. All
            rights reserved.
          </p>
        </div>
      </div>
    </section>;
}